module.exports = __webpack_public_path__ + "img/hygiene3.add97b6c.jpg";